import { usePlaylists } from '@/hooks/api/usePlaylists';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';
import React from 'react';
import { NumberCompactFormat } from '@/components/common/NumberCompactFormat';
import ReactTimeAgo from 'react-time-ago';
import { useRankings } from '@/hooks/api/useRankings';

export const Rankings = () => {
  const { data: rankings } = useRankings();

  return (
    <>
      {rankings?.map((ranking) => (
        <section key={ranking.id} className="top-movies">
          <h2 className="section-title">{ranking.name}</h2>
          <Swiper slidesPerView={'auto'} centeredSlides={false}>
            {ranking.channel_posts.map((cp) => (
              <SwiperSlide key={`r-${ranking.id}-${cp.id}`}>
                <Link to={`/channels/${cp.channel_outline.cid}/channel_posts/${cp.id}`} className="swiper-slide">
                  <div className="cover-wrapper">
                    <img src={cp.cover_image_url} className="cover" />
                    <span className="time">{cp.channel_post_movie.duration_label}</span>
                  </div>

                  <div className="content">
                    <h5>{cp.title}</h5>
                    <ul className="meta">
                      <li>
                        <NumberCompactFormat val={cp.movie_plays_count} />
                        回視聴
                      </li>
                      <li>
                        <ReactTimeAgo date={new Date(cp.posted_at)} locale="ja" />
                      </li>
                    </ul>
                  </div>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </section>
      ))}
    </>
  );
};
